module.exports = __webpack_public_path__ + "static/media/cal-logo.87f79e54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cal-logo.svg
// module id = 200
// module chunks = 0